module.exports = __webpack_public_path__ + "img/444.907135a5.png";